import React from 'react'
import { Player } from 'types/global'
import styles from './sidePlayers.module.scss'
import MatchCardPlayer from './MatchCardPlayer'
import { MatchUpTypeEnum } from 'types/api/enums'
import classNames from 'classnames'
import { OPTED_OUT_PLAYER_NAME } from 'constants/profile'

interface Props {
  side: Player[]
  iconType?: 'flag' | 'avatar'
  isWinner?: boolean
  truncateName?: boolean
  matchType: MatchUpTypeEnum
  sideNumber: number
  showRating: boolean
  showConfidence: boolean
  withLink: boolean
}

const SidePlayers = ({
  side,
  matchType,
  showRating,
  showConfidence,
  withLink,
  iconType = 'flag',
  isWinner = false,
  truncateName = false,
  sideNumber,
}: Props) => {
  let thisSide = [...side]
  const isByeMatch = !thisSide.length

  if (isByeMatch) {
    const dummy: Player = {
      id: '',
      firstName: OPTED_OUT_PLAYER_NAME,
      optedOutOfPublicDataConsent: true,
    }
    thisSide = matchType === MatchUpTypeEnum.SINGLES ? [dummy] : [dummy, dummy]
  }

  return (
    <>
      <p className={styles.screenReaderOnly}>{isByeMatch ? 'BYE' : `Side ${sideNumber}:`}</p>
      <ul
        className={classNames(styles.side, { [styles.byeContainer]: isByeMatch })}
        aria-hidden={isByeMatch}
      >
        {thisSide.map((p: Player, i) => (
          <li key={p.id || i}>
            <MatchCardPlayer
              player={p}
              iconType={iconType}
              className={classNames({
                [styles.winner]: isWinner && !isByeMatch,
                [styles.placeholder]: isByeMatch,
              })}
              truncateName={truncateName}
              aria-hidden={isByeMatch}
              showRating={showRating}
              showConfidence={showConfidence}
              withLink={withLink}
            />
          </li>
        ))}
        {isByeMatch && <li className={styles.bye}>BYE</li>}
      </ul>
    </>
  )
}

export default SidePlayers
